(()=>{
 let frame=0,bar,resizeObserver;
 const watchedRoots=new WeakSet();
 const observer=new MutationObserver(schedule);
 const update=()=>{
  frame=0;
  const root=document.documentElement,chat=document.querySelector('shopify-chat');if(!chat)return;
  const nextBar=document.querySelector('.bc-mix-bar');
  if(nextBar!==bar){resizeObserver?.disconnect();bar=nextBar;if(bar&&'ResizeObserver'in window){resizeObserver=new ResizeObserver(schedule);resizeObserver.observe(bar);}}
  const r=bar?.getBoundingClientRect(),visible=bar&&!bar.hidden&&getComputedStyle(bar).visibility!=='hidden'&&r.height>0&&r.top<innerHeight&&r.bottom>0;
  const nearChat=visible&&r.right>innerWidth-180;
  const offset=nearChat?Math.max(16,Math.ceil(innerHeight-r.top+8))+'px':'calc(16px + env(safe-area-inset-bottom,0px))';
  if(root.style.getPropertyValue('--bc-chat-offset')!==offset)root.style.setProperty('--bc-chat-offset',offset);
  const designer=document.querySelector('bullseye-designer'),uploadRoot=document.querySelector('bullseye-upload')?.shadowRoot;
  if(uploadRoot&&!watchedRoots.has(uploadRoot)){watchedRoots.add(uploadRoot);observer.observe(uploadRoot,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','open']});}
  const hide=!!document.querySelector('dialog[open]')||!!uploadRoot?.querySelector('dialog[open]')||!!designer?.fullscreen||!!designer?.desktopStarted;
  if(root.hasAttribute('data-bc-chat-hidden')!==hide)root.toggleAttribute('data-bc-chat-hidden',hide);
 };
 function schedule(){if(!frame)frame=requestAnimationFrame(update);}
 observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','open','class']});
 window.addEventListener('load',schedule,{once:true});
 window.addEventListener('resize',schedule);window.visualViewport?.addEventListener('resize',schedule);
 schedule();
})();
